module.exports = __webpack_public_path__ + "img/close_model.70ff1a5d.svg";